export enum RootRoleId {
  Administrator = '019e8cdd-0a85-7efd-9985-6b10c14fceb0',
  Manager = '019e8cdd-0a85-7a74-bc70-f6a6c8ec66f7',
  User = '019e8cdd-0a85-7adc-9541-2507d2182041',
}

export enum RoleType {
  Administrator = 'administrator',
  Manager = 'manager',
  User = 'user',
  Custom = 'custom',
}
